/**
 * Copyright (c) Qwoach LLC 2024. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 20.08.24
 *
 */
import BaseObject from "@shared/BaseObject.js";
import QwoachFile from "@shared/Drive/QwoachFile";
import {Type} from "@qwoach/class-transformer-wrapper";

export default class QwoachFileResponse extends BaseObject {


	count: number = 0

	@Type(() => QwoachFile)
	files: QwoachFile[] = []
}
